export const locale = {
    lang: 'tr',
    data: {
        MAIL: {
            COMPOSE                 : 'YENİ E-POSTA',
            FOLDERS                 : 'KLASÖRLER',
            FILTERS                 : 'FİLTRELER',
            LABELS                  : 'ETİKETLER',
            NO_MESSAGES             : 'Mesajiniz bulunmamakta!',
            SELECT_A_MESSAGE_TO_READ: 'Okumak için bir mesaj seçin',
            SEARCH_PLACEHOLDER      : 'E-mail yada bir kişi arayın'
        }
    }
};
